export const createAuthHeaders = (): Record<string, string> => {
  return {
    'x-client-id': import.meta.env.VITE_CLIENT_ID,
    'x-signed-secret': import.meta.env.VITE_SIGNED_SECRET,
    'x-timestamp': Math.floor(Date.now() / 1000).toString(),
  };
};
